import React, { useState } from 'react';
import { Container, Row, Col, Form, FormGroup } from 'reactstrap';
// import Img from "gatsby-image"
import { Subtitle, Description, Title } from '../../components/title/index';
import Image from '../../components/image/index';
import ContactImg from '../../assets/images/contact/woman.png';
import InputBox from '../../components/input/index';
import Button from '../../components/button';
import ContactBackgroundImages from '../../data/contact';
import '../contact/contact.scss';


const Contact = () => {

    const [name, setName] = useState('');
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');
    const [errors, setErrors] = useState({});

    const handelSubmit = () => {
        const error = {}
        if (!name) {
            error.name = 'First Name field shouldn’t be empty';
        }
        if (!subject) {
            error.subject = 'Subject field shouldn’t be empty';
        }
        if (!message) {
            error.message = 'Message field shouldn’t be empty';
        }

        if (error.name || error.subject || error.message) {
            setErrors(error);
        } else {
            window.location.href = `mailto:jamie@ngtts.co.uk?subject=${subject}&body=${encodeURIComponent(message)}`;
            setName('');
            setSubject('');
            setMessage('');
        }
    }

    return (
        <section className="contact-wrapper" id="contact">
            <div className="contact-animation-images">
                {ContactBackgroundImages.map((img, index) => (
                    <span key={`contact-img-${index}`} className={`image${index + 1}`}><Image Path={img.img} /></span>
                ))}
            </div>
            <Container>
                <Row>
                    <Col sm={0} md={6}>
                        <div className="contact-image">
                            {/* <Img fluid={data.placeholderImage.childImageSharp.fluid} /> */}
                            {/*<Image Path={ContactImg} Class="logo-img" />*/}
                        </div>
                    </Col>
                    <Col md={6}>
                        <div className="contact-content-block main-title-wrapper">
                            <Subtitle
                                Class="sitemain-subtitle"
                                Name="Send us mesage for more Info"
                            />
                            <Description
                                Class="contact-dec"
                                Name="Get In Touch"
                            />
                            <div className="form">

                                    <FormGroup>
                                        <Title Class="form-label" Name="Name *" />
                                        <InputBox
                                            Type="text"
                                            Name="name"
                                            PlaceHolder="Full Name"
                                            Value={name}
                                            ChangeValue={setName}
                                            Class={errors && errors.name && 'error'}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Title Class="form-label" Name="Subject *" />
                                        <InputBox
                                            Type="text"
                                            Name="text"
                                            PlaceHolder="Subject"
                                            Value={subject}
                                            ChangeValue={setSubject}
                                            Class={errors && errors.subject && 'error'}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Title Class="form-label" Name="Message *" />
                                        <InputBox
                                            Type="textarea"
                                            Name="text"
                                            PlaceHolder="Your Message"
                                            Class={`textbox ${errors && errors.message && 'error'}`}
                                            Value={message}
                                            ChangeValue={setMessage}
                                        />
                                    </FormGroup>

                            </div>
                            <Button
                                Class="button1 btn button2 gradient-color"
                                Name="SUBMIT"
                                Clickble={handelSubmit}
                                BtnIcon="btn-icon"
                            />
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Contact;
